function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 10C11.4477 10 11 9.55228 11 9V5.0874L9.39816 6.75072L9.30655 6.83292C8.98667 7.07959 8.53199 7.05323 8.24087 6.75318C7.92064 6.42313 7.91958 5.88692 8.2385 5.55551L11.4202 2.24928L11.5121 2.16687C11.8329 1.91965 12.2891 1.94712 12.5798 2.24928L15.7615 5.55551L15.8405 5.65066C16.0776 5.98271 16.0502 6.45314 15.7591 6.75318L15.6672 6.83499C15.3463 7.0803 14.8918 7.052 14.6018 6.75072L13 5.08684V9C13 9.55228 12.5523 10 12 10Z",
  fill: "#8C8DA0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 14C12.5523 14 13 14.4477 13 15V18.9126L14.6018 17.2493L14.6935 17.1671C15.0133 16.9204 15.468 16.9468 15.7591 17.2468C16.0794 17.5769 16.0804 18.1131 15.7615 18.4445L12.5798 21.7507L12.4879 21.8331C12.1671 22.0803 11.7109 22.0529 11.4202 21.7507L8.2385 18.4445L8.15945 18.3493C7.92241 18.0173 7.94975 17.5469 8.24087 17.2468L8.33282 17.165C8.65367 16.9197 9.10824 16.948 9.39816 17.2493L11 18.9132V15C11 14.4477 11.4477 14 12 14Z",
  fill: "#8C8DA0"
});

function SvgUndoMerge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoMerge);
export default __webpack_public_path__ + "static/media/undo-merge.98cfe60f.svg";
export { ForwardRef as ReactComponent };